import { doc, Firestore, serverTimestamp, updateDoc } from 'firebase/firestore'
import { binChecklist } from './elementRestructureService'
import { emitCanonicalChecklistActivity } from './checklistMutationService'
import { recalculateElementProgressTree } from './cascadeEngine'
import type { TimelineElement } from '../types/timelineElement'
import type { TimelineBoardKey } from '../types/schema'

type LegacyChecklistItem = TimelineElement['checklist'][number]

export const moveChecklistToBin = async ({
  targetId,
  targetTitle,
  workspaceId,
  parentContainerId,
  currentUser,
  currentDisplayName,
  firestoreDb,
  legacyChecklistUpdate,
}: {
  targetId: string
  targetTitle: string
  workspaceId: string
  board: TimelineBoardKey | null | undefined
  deletedFromBoard: TimelineBoardKey | null | undefined
  parentContainerId: string
  currentUser: { uid: string; email?: string | null } | null
  currentDisplayName: string | null
  firestoreDb: Firestore
  legacyChecklistUpdate?: LegacyChecklistItem[]
}) => {
  await binChecklist(workspaceId, [targetId])
  await emitCanonicalChecklistActivity(firestoreDb, {
    workspaceId,
    actor: { id: currentUser?.uid, name: currentDisplayName || currentUser?.email },
    targetId,
    targetTitle,
    action: 'CHECKLIST_DELETED',
    summary: `Moved checklist item ${targetTitle} to Bin`,
    board: 'BIN',
  }).catch((error) => console.warn('[checklistBinService] delete activity write failed', error))

  if (legacyChecklistUpdate) {
    await updateDoc(doc(firestoreDb, 'elements', parentContainerId), {
      checklist: legacyChecklistUpdate,
      lastUpdatedAt: serverTimestamp(),
    }).catch((error) => console.warn('[checklistBinService] legacy mirror cleanup failed', error))
  }

  await recalculateElementProgressTree(firestoreDb, parentContainerId).catch((error) => console.warn('[checklistBinService] recalculate tree failed', error))
}
